import script from "./switch-tabs.vue?vue&type=script&setup=true&lang=js"
export * from "./switch-tabs.vue?vue&type=script&setup=true&lang=js"

import "./switch-tabs.vue?vue&type=style&index=0&id=b8d3a380&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b8d3a380"]])

export default __exports__